module.exports = __webpack_public_path__ + "img/hills.a29e49df.jpg";